import { render, staticRenderFns } from "./PostDetails.vue?vue&type=template&id=7d1381c6&scoped=true&"
import script from "./PostDetails.vue?vue&type=script&lang=js&"
export * from "./PostDetails.vue?vue&type=script&lang=js&"
import style0 from "./PostDetails.vue?vue&type=style&index=0&id=7d1381c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1381c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d1381c6')) {
      api.createRecord('7d1381c6', component.options)
    } else {
      api.reload('7d1381c6', component.options)
    }
    module.hot.accept("./PostDetails.vue?vue&type=template&id=7d1381c6&scoped=true&", function () {
      api.rerender('7d1381c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/campaign/PostDetails.vue"
export default component.exports